/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { SqlImportPreviewWarnings } from 'cio/utils/sql-import';

type TransformedWarning = {
  title: string;
  message: string;
  action?: string;
  onClick?: () => unknown;
};

interface SqlImportsPreviewWarningsArgs {
  warnings: string[];
}

export default class SqlImportsPreviewWarnings extends Component<SqlImportsPreviewWarningsArgs> {
  get transformedWarnings() {
    return this.args.warnings?.map((w: SqlImportPreviewWarnings) => this.transformWarning(w));
  }

  private transformWarning(warning: SqlImportPreviewWarnings): TransformedWarning {
    // If there are sensitive fields, their names are included right after, so we
    // can extract and show those to the user.
    if (warning?.startsWith('sensitive_fields_found: ')) {
      let fields = warning.replace('sensitive_fields_found: ', '');
      return {
        title: `You've included at least one field (${fields}) that you should not import into Customer.io.`,
        message: `These fields include passwords, credit card numbers, or personal identifiable information (PII) for people under 18 years old.`,
      };
    } else {
      return {
        select_star_query: {
          title: '* queries are not recommended.',
          message: 'You should specify the columns you want to sync to your workspace.',
        },
        limit_not_present: {
          title: 'You are not using {{last_sync_time}} to limit your sync.',
          message: `We strongly recommend that you limit your query to the columns that changed since the last sync using {{last_sync_time}}. <a href="https://customer.io/docs/sql-sync/#last-sync-time" rel="noopener noreferrer" target="_blank">Learn more</a>`,
        },
        result_not_present: {
          title: 'There are no results present.',
          message: 'The query is syntactically correct but returned no results.',
        },
        not_a_select_query: {
          title: 'Non-select queries are not recommended.',
          message: 'The query should only be selecting the data you want to sync.',
        },
      }[warning as Exclude<SqlImportPreviewWarnings, 'sensitive_fields_found'>];
    }
  }
}
